import CustomFunctionsModal from "./CustomFunctions/CustomFunctions";

export default {
  CustomFunctionsModal,
};
